<template>
  <div>
    <b-modal
      id="modal-detail"
      size="lg"
      centered
      scrollable
      title="Detail Lowongan Kerja"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <!-- <div
        style="
          text-align: center;
          padding: 2%;
          font-weight: 600;
          font-size: 21px;
        "
      >
        {{ data.namaLoker }}
      </div> -->
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-table-simple borderless small>
            <b-tbody>
              <b-tr>
                <b-td style="width: 35%">Judul Loker</b-td>
                <b-td>:</b-td>
                <b-td>{{ data.namaLoker }}</b-td>
              </b-tr>

              <b-tr>
                <b-td>Posisi</b-td>
                <b-td>:</b-td>
                <b-td>{{ data.namaPosisi }}</b-td>
              </b-tr>

              <b-tr>
                <b-td>Kriteria Umur</b-td>
                <b-td>:</b-td>
                <b-td>{{ data.umurMinimal }} s/d {{ data.umurMaksimal }}</b-td>
              </b-tr>

              <b-tr>
                <b-td>Deadline Lowongan</b-td>
                <b-td>:</b-td>
                <b-td>{{ data.tglAkhir }}</b-td>
              </b-tr>

              <b-tr>
                <b-td>Keterangan</b-td>
                <b-td>:</b-td>
                <b-td><span v-html="data.keteranganLoker"></span></b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-detail')">
          Batal
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "modalDetail",
  props: ["data", "detail"],
  data() {
    return {
      src1: "",
      src2: "",
    };
  },
  watch: {
    detail: function (newVal, oldVal) {
      if (oldVal != newVal) {
        this.src1 = "";
        this.src2 = "";
        if (this.data.fotoProfilKaryawan != null) {
          this.src1 = `${this.$be}asset/file/${this.data.fotoProfilKaryawan}`;
        }
        if (this.data.fotoKKKaryawan != null) {
          this.src2 = `${this.$be}asset/file/${this.data.fotoKKKaryawan}`;
        }
      }
    },
  },
};
</script>
